/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { user } from 'rxfire/auth';
import { take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

/**
 * looks for the legacy hashbang (kinda) in the url, and redirects to the non-hashbang version
 * isolating this out to explain and test it easier.
 * *note* this will fail if we actually start using url fragments (#segments in the url)
 * *note 2* we can't do this in any normal way (see TP-5253) because the # symbol seems to break everything
 */
export const patchLegacyHashBang = (routerFragment: string | null): string[] => {
	if (routerFragment && routerFragment[0] === '!') {
		return routerFragment.split('/').slice(1);
	}
	return [];
};

/**
 * A fallback route guard to handle accessing routes that don't exist. The hashbang check relies on throwing
 * the request back into the void, where it will be caught a second time by this method if it still doesn't match.
 * @param route
 * @param state
 * @returns
 */
export const defaultRouteGuard = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
): Promise<boolean> => {
	const router = inject(Router);
	const auth = inject(Auth);

	const legacyCheck = patchLegacyHashBang(route.fragment);
	if (legacyCheck.length) {
		router.navigate(legacyCheck);
		return Promise.resolve(false);
	}

	const hasAuth = firstValueFrom(user(auth).pipe(take(1)));

	return hasAuth.then((success) => {
		if (success) {
			router.navigate(['projects']);
		} else {
			router.navigate(['auth']);
		}
		return false;
	});
};
